export function isBrowserEnv () {
  return !process.version
}
